
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deeplink",
      function () {
        return require("private-next-pages/deeplink.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deeplink"])
      });
    }
  